/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithAllowMultiple
 */
export interface WithAllowMultipleOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithAllowMultiple
   */
  allowMultiple?: boolean;
}

export interface WithAllowMultiple extends WithAllowMultipleOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithAllowMultiple
   */
  allowMultiple?: boolean;
}

export interface WithAllowMultipleTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof WithAllowMultiple
   */
  allowMultiple?: boolean;
  allowMultipleIsSet: boolean;
}

transformDatesMap.set(
  "WithAllowMultiple",
  function (model: WithAllowMultiple) {},
);

export type WithAllowMultipleMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  allowMultiple: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var WithAllowMultipleMeta: WithAllowMultipleMetaI =
  {} as WithAllowMultipleMetaI;
WithAllowMultipleMeta = typeMeta("WithAllowMultiple", {
  allowMultiple: propertyMeta(
    "allowMultiple",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = WithAllowMultipleMeta;

registerMeta(() => {});

export class WithAllowMultipleTracked implements WithAllowMultipleTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  allowMultiple__I?: boolean = undefined;
  allowMultipleIsSet: boolean = false;
  set allowMultiple(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowMultiple__I = v;
      this.allowMultipleIsSet = true;
    } else {
      this.allowMultiple__I = v || undefined;
      this.allowMultipleIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowMultiple() {
    return this.allowMultiple__I;
  }
  constructor(config?: WithAllowMultipleOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithAllowMultipleOptional,
    options?: AssignOptions,
  ): WithAllowMultipleTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.allowMultiple &&
      this.allowMultipleApplyFilter(optionsRequired.filter)
    ) {
      this.allowMultiple = config.allowMultiple;
      if (optionsRequired.unassign) this.allowMultipleIsSet = false;
      else this.allowMultipleIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithAllowMultipleTrackedI {
    const cloned = {} as WithAllowMultipleTrackedI;
    if (
      this.allowMultipleIsSetDeep() &&
      this.allowMultipleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowMultipleIsSet = true;
      cloned.allowMultiple = this.allowMultiple;
    } else {
      //cloned.allowMultipleIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithAllowMultipleTrackedI {
    if (!this.allowMultipleApplyFilter(filter)) this.allowMultipleIsSet = false;

    return this;
  }
  allowMultipleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithAllowMultipleMeta.allowMultiple,
      WithAllowMultipleMeta,
      this.allowMultiple,
      this,
    );
  }
  allowMultipleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowMultipleIsSet && this.allowMultipleApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.allowMultipleIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
